var map = {
	"./skins/IBC-dyst-2025": [
		135,
		13
	],
	"./skins/IBC-dyst-2025.css": [
		399,
		29
	],
	"./skins/IBC-dyst-2025.js": [
		135,
		13
	],
	"./skins/aktionaerliga-2024": [
		136,
		12
	],
	"./skins/aktionaerliga-2024.css": [
		400,
		28
	],
	"./skins/aktionaerliga-2024.js": [
		136,
		12
	],
	"./skins/bibliotekarernes-sep-2024": [
		137,
		11
	],
	"./skins/bibliotekarernes-sep-2024.css": [
		401,
		27
	],
	"./skins/bibliotekarernes-sep-2024.js": [
		137,
		11
	],
	"./skins/boersen-spiel-sep-2024": [
		138,
		10
	],
	"./skins/boersen-spiel-sep-2024.css": [
		402,
		26
	],
	"./skins/boersen-spiel-sep-2024.js": [
		138,
		10
	],
	"./skins/borsgruppenliu-jan-2024": [
		139,
		9
	],
	"./skins/borsgruppenliu-jan-2024.css": [
		403,
		25
	],
	"./skins/borsgruppenliu-jan-2024.js": [
		139,
		9
	],
	"./skins/fynske-bank-sep-2024": [
		140,
		8
	],
	"./skins/fynske-bank-sep-2024.css": [
		404,
		24
	],
	"./skins/fynske-bank-sep-2024.js": [
		140,
		8
	],
	"./skins/ibc-jan-2024": [
		141,
		14
	],
	"./skins/ibc-jan-2024.js": [
		141,
		14
	],
	"./skins/sdu-businessschooldays-2024": [
		142,
		7
	],
	"./skins/sdu-businessschooldays-2024.css": [
		405,
		23
	],
	"./skins/sdu-businessschooldays-2024.js": [
		142,
		7
	],
	"./skins/skoledyst-oct-2023": [
		143,
		6
	],
	"./skins/skoledyst-oct-2023.css": [
		406,
		22
	],
	"./skins/skoledyst-oct-2023.js": [
		143,
		6
	],
	"./skins/skolernes-aktiedyst-2024": [
		144,
		5
	],
	"./skins/skolernes-aktiedyst-2024.css": [
		407,
		21
	],
	"./skins/skolernes-aktiedyst-2024.js": [
		144,
		5
	],
	"./skins/sommerdysten-ad-2023": [
		145,
		4
	],
	"./skins/sommerdysten-ad-2023.css": [
		408,
		20
	],
	"./skins/sommerdysten-ad-2023.js": [
		145,
		4
	],
	"./skins/sommerdysten-ak-2023": [
		146,
		3
	],
	"./skins/sommerdysten-ak-2023.css": [
		409,
		19
	],
	"./skins/sommerdysten-ak-2023.js": [
		146,
		3
	],
	"./skins/sommerdysten-is-2023": [
		147,
		2
	],
	"./skins/sommerdysten-is-2023.css": [
		410,
		18
	],
	"./skins/sommerdysten-is-2023.js": [
		147,
		2
	],
	"./skins/sydbank-sep-2020": [
		148,
		1
	],
	"./skins/sydbank-sep-2020.css": [
		411,
		17
	],
	"./skins/sydbank-sep-2020.js": [
		148,
		1
	],
	"./skins/ungdomsudddyst-oct-2024": [
		149,
		0
	],
	"./skins/ungdomsudddyst-oct-2024.css": [
		412,
		16
	],
	"./skins/ungdomsudddyst-oct-2024.js": [
		149,
		0
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 295;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/dynamic lazy ^\.\/.*$
// module id = 295
// module chunks = 30